<template>
  <div class="page-ranking common-wrap">
    <div class="top-select-tit">
      <ul class="select clearfix">
        <li :class="{active: isTotal === false}"  @click="loadRank(false)">月排行榜</li>
        <li :class="{active: isTotal === true}" @click="loadRank(true)">总排行榜</li>
      </ul>
      <div class="mine-rank" v-if="showMyRank==true">
        我的当前排名：<span class="red">{{myRank}}</span>，高于<span class="red">{{myRankRate}}%</span>的用户
      </div>
      <div class="gonglue" @click="showGonglueEvent">
        <i>?</i>攻略
      </div>
    </div>
    <div class="rank-list">

      <div class="item clearfix"  v-for="(item, index) in tableData"
           :key="index">
        <div class="num">{{index+1}}</div>
        <router-link
                :to="{
                  path: '/home',
                  query: { userId: item.userId }
                }"
                target="_blank"
                class="name"
        >
          <div class="infos clearfix">
            <div class="avatar" :style="{'background-image': 'url(' + `http://iss.21teacher.com/avatar/125/${item.userId}/20.jpg` + ')'}"></div>
            <div class="name-deng">
              <div class="u-name clearfix">
                <div class="nc-name">{{item.userName}}</div>

                <div class="new-tchh clearfix"
                        v-if="
                    item.rankName != '' &&
                      item.rankName != null "
                >
                  <i class="icon zs"
                          v-if="item.rankName.split(',')[1] == '资深作者'"
                  ></i>
                  <i
                          class="icon yx"
                          v-if="item.rankName.split(',')[1] == '优秀作者'"
                  ></i>
                  <i
                          class="icon hy"
                          v-if="item.rankName.split(',')[1] == '活跃作者'"
                  ></i>
                  <span class="zuoz">{{
                    item.rankName.split(",")[1]
                  }}</span>
                  <span class="shu">|</span>
                  <span class="liny">{{item.rankName.split(",")[0]}}</span>
                </div>

              </div>
              <div class="qianm">
                {{item.signature}}
              </div>
            </div>
          </div>
        </router-link>
        <div class="fen-count">{{item.totalVal}}</div>
      </div>

    </div>
    <el-dialog
      title="影响力攻略"
      top="40px"
      :visible.sync="dialogVisible"
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
      center
    >
      <div class="gonglue-cont">
        <p>发布作品  奖励1点，入选“精选”作品，额外奖励1点。</p>
        <p>分享作品 奖励0.1点。每日最高奖励0.5点。</p>
        <p>评论作品 奖励0.1点，每日最高奖励0.5点。如果评论同时收集10个点赞，额外奖励1点。</p>
        <!--<p>评论并转发作品 奖励0.2点。每日最高奖励1点。</p>-->
        <br>
        <p>发布文章  奖励1点。</p>
        <p>分享文章 奖励0.1点。每日最高奖励0.5点。</p>
        <p>评论文章 奖励0.1点，每日最高奖励0.5点。如果评论同时收集10个点赞，另奖励1点。</p>
        <!--<p>评论并转发文章 奖励0.2点。每日最高奖励1点。</p> ，入选“精选”作品，奖励翻1倍-->
        <br>
        <p>发布问题  奖励0.1点，</p>
        <p>回答问题 奖励0.25点，被采纳为最佳额外奖励1点。</p>
        <p>邀请问答 奖励0.1/人，邀请多人回答问题，最高奖励1点。</p>
        <br>
        <p>参与活动 奖励2点。作品获奖，额外奖励4点。</p>
        <br>
        <p>标签被认可 A认可B的标签，A和B同时奖励0.1,每日最高奖励0.5。</p>
        <p>添加好友印象 A给B添加好友印象，A和B同时奖励0.1，每日最高奖励0.5</p>
        <br>
        <p>基本资料 奖励10点。（完成度100%以后才给予奖励）</p>
        <p>教育经历 奖励10点。（完成度100%以后才给予奖励）</p>
        <p>工作经历 奖励15点。（完成工作经历，奖励15点）</p>
        <br>
        <!-- <p>邀请好友注册 奖励1点</p> -->
        <p>新用户首次登陆奖励0.1点/人。</p>
        <br>
        <p>观看作品时长</p>
        <p>1分钟以内 奖励0.1</p>
        <p>15分钟以内 奖励0.25</p>
        <p>30分钟以内 奖励0.75</p>
        <p>1小时以上 奖励1.75</p>
        <div class="ask-user">上述内容是否对您有用？</div>
        <div class="articled-zan-cai">
          <div class="item" :class="{ active:likeFlag }" v-on:click="likeEvent(999,null)">
            <i class="icon zan"></i>
            <span>{{likeCount}}</span>
          </div>
          <div class="item" :class="{ active: disLikeFlag }" v-on:click="disLikeEvent(999,null)">
            <i class="icon cai"></i>
            <span>{{disLikeCount}}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import axios from 'axios';
  import vue from 'vue';

  import { mapState } from "vuex";
  import updateTdk from "@/utils/tdk";
  import apiService from '@/api/index';
  import global_ from '@/api/global';

  vue.prototype.$axios = axios;
  export default {
    components: {

    },
    data () {
      return {
        headTitle: "title---rrdh",
        headKeywords: "keywords---rrdh",
        headDesc: "description---rrdh",
        isMounted: false, //for control not ssr render
        dialogVisible: false,
        tableData: [],
        userId:0,
        isTotal: false,
        myRank:0,
        myRankRate:0.00,
        callbackurl:"",
        isLogin: false,
        disLikeCount:0,
        likeCount:0,
        likeFlag:false,
        disLikeFlag:false,
        showMyRank:false
      }
    },
    computed: {
      ...mapState(["userDetail"])
    },
    tdk() {
      return {
        title: this.headTitle,
        description: this.headDesc,
        keywords: this.headKeywords,
        ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
      };
    },
    serverPrefetch() {
      return this.fetchData();
    },
    destroyed() {
      this.$store.commit("SET_USER_DETAIL", { detail: null });
    },
    mounted() {
      this.isMounted = true;

      let userId=this.$route.query.userId;
      let total=this.$route.query.total;
      this.userId=userId;
      if(total=="true"){
        this.isTotal=true;
      }

      const alreadyIncremented = !!this.productionDetail;
      if (!alreadyIncremented) {
        this.fetchData().then(this.initData());
      } else {
        this.initData();
      }
    },
    methods:{
      showGonglueEvent () {
        this.dialogVisible = true
      },
      loadRank(total){
        this.isTotal=total;
        this.search(1);
      },
      fetchData(){
        return this.$store
                .dispatch("FETCH_USER_DETAIL", {
                  id:this.$route.query.userId
                })
                .finally(() => {
                  this.$loading(false);
                  console.log("this.userDetail =====  ",this.userDetail)
                  this.setSeo()
                  updateTdk.call(this);
                  if(global_.isLogin){
                    // this_.loginUserId = this.global.userModel.id
                    this.isLogin = true;
                    this.showMyRank = true;
                  }
                });
      },
      initData(){
        this.search(1)
      },
      search(page){
        let _this = this
        _this.fullscreenLoading = true;
        let url = '/rrbi/influence/rankList?userId=' + _this.userId + '&isTotal=' + _this.isTotal+ "&ti=" + new Date().getMilliseconds();
        _this.$axios.get(url).then(function (result) {
          console.log("###############");
          console.log(result.data.response);
          _this.tableData = result.data.response.rankList;
         _this.myRank= result.data.response.myRank;
         _this.myRankRate= result.data.response.myRankRate;
         _this.disLikeCount= result.data.response.disLikeCount;
         _this.likeCount= result.data.response.likeCount;
         _this.likeFlag= result.data.response.likeFlag;
         _this.disLikeFlag= result.data.response.disLikeFlag;
          _this.fullscreenLoading = false
        })
      },
      setSeo(){
        this.headTitle = "影响力排行榜——人人动画网【官网】";
        //this.headKeywords = this.activityInfoDetail.showProType;
        this.headDesc ="影响力排行榜";
      },
      likeEvent(id,belongSection){
        var _this =this;
        if(this.global.isLogin){
          apiService.dolike({"objectType":10,"objectId":id,"belongSection":belongSection,"time": new Date().getMilliseconds()}).then(data => {
            if(_this.likeFlag){
              _this.likeCount=Number(_this.likeCount)-1;
              _this.likeFlag=false;
            }else{
              _this.likeCount=Number(_this.likeCount)+1;
              _this.likeFlag=true;
            }
            // _this.initData();
            //console.log("_this.loadShow===",_this.loadShow)
          })
        }else{
          // window.location.href="http://www.renrendonghua.com/"+_this.callbackurl;
          _this.$message({
            message: '您尚未登录,请登录后操作',
            type: 'error'
          });
        }
      },
      disLikeEvent(id,belongSection){
        var _this =this;
        if(this.global.isLogin) {
          apiService.dislike({"objectType":10, "objectId": id,"belongSection":belongSection,"time": new Date().getMilliseconds()}).then(data => {
            if(_this.disLikeFlag){
              _this.disLikeCount=Number(_this.disLikeCount)-1;
              _this.disLikeFlag=false;
            }else{
              _this.disLikeCount=Number(_this.disLikeCount)+1;
              _this.disLikeFlag=true;
            }
          })
        }else{
          window.location.href="http://www.renrendonghua.com/"+_this.callbackurl;
          _this.$message({
            message: '您尚未登录,请登录后操作',
            type: 'error'
          });
        }
      }
    }
  }
</script>

<style scoped lang="less">
@import "./ranking.less";
</style>
